export default "__VITE_ASSET__BwNWjd$g__"